import type { ViewModes } from '../../../types/view';
import type { PanelSectionId } from './types';

// The workspace URL carries the open panel section (`tab`) and the 3D view mode (`view`), so a
// shared link opens the same place. Export keeps the legacy `tab=exports` (WorkspacePage owns it).

const URL_TABS: readonly PanelSectionId[] = ['layers', 'luminaires', 'results', 'surfaces', 'market'];

/** `tab` values that name a panel section (besides the legacy `process` / `exports`). */
export const isPanelTab = (tab: string | null): tab is PanelSectionId =>
  tab != null && (URL_TABS as readonly string[]).includes(tab);

export type UrlViewMode = Exclude<keyof ViewModes, 'object'>;

const URL_VIEWS: readonly UrlViewMode[] = ['measurement', 'render', 'realTimeRender'];

/** The view mode a link asks for; the default 3D scene is simply no `view`. */
export const parseViewParam = (view: string | null): UrlViewMode | null =>
  view != null && (URL_VIEWS as readonly string[]).includes(view) ? (view as UrlViewMode) : null;
